import type { RhythmPayload } from "./schema";

export interface RhythmTapResult {
  readonly token: string;
  readonly expectedToken: string;
  readonly offsetMs: number;
  readonly errorMs: number;
  readonly tokenCorrect: boolean;
  readonly onBeat: boolean;
}

export interface RhythmResult {
  readonly score: number;
  readonly correctRate: number;
  readonly rhythmAccuracy: number;
  readonly replayCount: number;
  readonly durationMs: number;
  readonly taps: readonly RhythmTapResult[];
}

function clampUnit(value: number): number {
  return Math.min(1, Math.max(0, value));
}

export function calculateRhythmResult(
  payload: RhythmPayload,
  taps: readonly RhythmTapResult[],
  replayCount: number,
  durationMs: number
): RhythmResult {
  const total = payload.answerTokens.length;
  const relevantTaps = taps.slice(0, total);
  const correctTokens = relevantTaps.filter(
    ({ tokenCorrect }) => tokenCorrect
  ).length;
  const onBeatCorrectTokens = relevantTaps.filter(
    ({ tokenCorrect, onBeat }) => tokenCorrect && onBeat
  ).length;
  const correctRate =
    total === 0 ? 0 : clampUnit(correctTokens / total);
  const rhythmAccuracy =
    total === 0 ? 0 : clampUnit(onBeatCorrectTokens / total);
  const score = Math.round(
    100 * clampUnit(0.7 * correctRate + 0.3 * rhythmAccuracy)
  );

  return {
    score,
    correctRate,
    rhythmAccuracy,
    replayCount: Math.max(0, Math.floor(replayCount)),
    durationMs: Math.max(0, Math.round(durationMs)),
    taps: relevantTaps
  };
}
